<template>
    <div class="">
        <div class="container left">
            <div v-if="checkingAccess || loadingReportData">
                <div class="spacer s30"></div>
                <h3>
                    <span class="loading-spinner"><font-awesome-icon icon="spinner" class="fa-spin 3x" /></span>&nbsp; {{ status }}
                </h3>
            </div>

            <div class="spacer s10 desktop"></div>

            <div v-if="reportLoaded">
                <div>
                    <div class="spacer s30"></div>

                    <div class="box">
                        <div class="field">
                            <label class="label blue flex mb-4"><font-awesome-icon icon="info-circle" /> &nbsp;Report Title</label>
                            <p>{{ currentReport.title }}</p>
                        </div>
                    </div>

                    <div class="box">
                        <div class="field">
                            <label class="label blue flex mb-4"><font-awesome-icon icon="info-circle" /> &nbsp;Report Info</label>
                            <table class="table is-fullwidth">
                                <tbody>
                                    <tr>
                                        <th>Completed By:</th>
                                        <td>{{ currentReport.createdBy }}</td>
                                    </tr>
                                    <tr>
                                        <th>Report Month:</th>
                                        <td>{{ currentReport.month }} {{ currentReport.year }}</td>
                                    </tr>
                                    <tr>
                                        <th>Completed By:</th>
                                        <td>{{ currentReport.createdBy }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="box">
                        <div class="tabs is-boxed">
                            <ul>
                                <li :class="{ 'is-active': topTabs == '1' }" @click="topTabs = '1'">
                                    <a>
                                        Auditor Checklist &nbsp;<span
                                            class="tag is-small"
                                            :class="[auditorTally && auditorTally?.checked === auditorTally?.total ? 'is-success' : 'is-danger']"
                                            v-if="auditorTally">
                                            ({{ auditorTally.checked }}/{{ auditorTally.total }})</span
                                        >
                                    </a>
                                </li>
                                <li :class="{ 'is-active': topTabs == '2' }" @click="topTabs = '2'">
                                    <a>Completed Activities</a>
                                </li>
                                <li :class="{ 'is-active': topTabs == '3' }" @click="topTabs = '3'">
                                    <a>Compliance Data</a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content">
                            <div class="fullwidth" v-if="topTabs == '1'">
                                <div class="field">
                                    <label class="label blue flex mb-4"><font-awesome-icon icon="check-square" /> &nbsp;Auditor Checklist</label>
                                    <LiveDynamicChecklist
                                        key="auditChecklist"
                                        :readOnly="true"
                                        :exists="currentReport.exists"
                                        unsavedMessage="Save the report to add audit items here"
                                        addItemButtonText="Add Audit Item"
                                        inputType="text"
                                        :items="auditChecklistItems" />
                                </div>
                            </div>

                            <div class="fullwidth" v-if="topTabs == '2'">
                                <div class="field">
                                    <label class="label blue flex mb-4"
                                        ><span class="material-symbols-outlined"> checklist </span> &nbsp;Completed Activities</label
                                    >
                                    <LiveDynamicChecklist
                                        key="activities"
                                        :readOnly="true"
                                        :exists="currentReport.exists"
                                        addItemButtonText="Add Activity"
                                        inputType="paragraph"
                                        :items="activitiesItems" />
                                </div>
                            </div>

                            <div class="fullwidth" v-if="topTabs == '3'">
                                <div class="dash-audit-outer flex" v-if="currentReport.complianceData">
                                    <div v-for="(item, idx) in tallyAudits" :key="`dash-audit-items-${idx}`">
                                        <div v-if="item" class="dash-square-wrapper flex compact" @click="toAlerts(item.slugs)">
                                            <div class="ds-content">
                                                <div class="ds-header">
                                                    <span class="ds-icon" :style="{ color: item.color }">
                                                        <span class="material-icons-outlined s20"> {{ item.icon }} </span>
                                                    </span>
                                                    <span class="ds-title" :style="{ color: item.color }">{{ item.label }}</span>
                                                </div>
                                                <div class="ds-info" v-for="(detail, idx) in item.data" :key="`dash-audit-detail-${idx}`">
                                                    <div class="ds-details">{{ detail.label }}:</div>
                                                    <div
                                                        v-if="currentReport.complianceData"
                                                        class="ds-tally"
                                                        :style="{ color: getColor(currentReport.complianceData[detail.slug], detail.isRed) }">
                                                        {{ currentReport.complianceData ? currentReport.complianceData[detail.slug] : '0' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p class="orange bold italic">
                                        No nightly audit found for {{ currentReport?.reportDay ?? 'the selected day' }}.
                                        {{ months.find((m) => m.value === currentReport.reportMonth)?.label }} {{ currentReport.reportYear }}.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box">
                        <div class="tabs is-boxed">
                            <ul>
                                <li :class="{ 'is-active': tabsSummary == '1' }" @click="tabsSummary = '1'">
                                    <a>Summary</a>
                                </li>
                                <li :class="{ 'is-active': tabsSummary == '2' }" @click="tabsSummary = '2'">
                                    <a>Findings</a>
                                </li>
                                <li :class="{ 'is-active': tabsSummary == '3' }" @click="tabsSummary = '3'">
                                    <a> Follow Up Actions </a>
                                </li>
                                <li :class="{ 'is-active': tabsSummary == '4' }" @click="tabsSummary = '4'">
                                    <a>SMS Audits</a>
                                </li>
                                <li :class="{ 'is-active': tabsSummary == '5' }" @click="tabsSummary = '5'">
                                    <a>Feedback</a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content">
                            <div class="fullwidth" v-if="tabsSummary == '1'">
                                <label class="label blue flex mb-4">
                                    <span class="material-symbols-outlined"> export_notes </span>&nbsp;General Summary
                                </label>
                                <LiveDynamicChecklist
                                    key="summary"
                                    :exists="currentReport.exists"
                                    unsavedMessage="Save the report to add summary notes here"
                                    addItemButtonText="Add Summary Note"
                                    :readOnly="true"
                                    inputType="paragraph"
                                    :items="summaryItems" />
                            </div>

                            <div class="fullwidth" v-if="tabsSummary == '2'">
                                <label class="label blue flex mb-4">
                                    <span class="material-symbols-outlined"> text_compare </span>&nbsp;Findings and Recommendations
                                </label>
                                <LiveDynamicChecklist
                                    key="findingsRecs"
                                    :exists="currentReport.exists"
                                    heading=""
                                    unsavedMessage="Save the report to add items."
                                    addItemButtonText="Add Finding/Recommendation Pair"
                                    inputType="para-para"
                                    :readOnly="true"
                                    :items="findingsRecsItems" />
                            </div>
                            <div class="fullwidth" v-if="tabsSummary == '3'">
                                <label class="label orange flex mb-4">
                                    <span class="material-symbols-outlined"> pending_actions </span>&nbsp;Report Actions for
                                    {{ months.find((m) => m.value === currentReport.reportMonth)?.label }} {{ currentReport.reportYear }}
                                </label>
                                <LiveDynamicChecklist
                                    key="checklist"
                                    :exists="currentReport.exists"
                                    heading=""
                                    :readOnly="true"
                                    unsavedMessage="Save the report to add action items."
                                    addItemButtonText="Add Action Item"
                                    :items="checklistItems" />

                                <hr />
                                <div class="fullwidth">
                                    <label class="label green flex mb-2">
                                        <span class="material-symbols-outlined"> data_check </span>&nbsp;Completed Actions from last month (read only)
                                    </label>
                                    <div
                                        class="pl-3 flex column left"
                                        v-if="currentReport.previousChecklist?.filter((item) => item.checked).length > 0">
                                        <div
                                            class="flex green checklist-item"
                                            v-for="(item, idx) in currentReport.previousChecklist.filter((item) => item.checked)"
                                            :key="`completed-action-${idx}`">
                                            <span class="material-symbols-outlined"> check_box </span>&nbsp;{{ item.text }}
                                        </div>
                                    </div>
                                    <div v-else>No completed actions found.</div>
                                </div>

                                <hr />
                                <div class="fullwidth">
                                    <label class="label red flex mb-2">
                                        <span class="material-symbols-outlined"> pending_actions </span>&nbsp;Incomplete Actions from last month (read
                                        only)
                                    </label>
                                    <div
                                        class="pl-3 flex column left"
                                        v-if="currentReport.previousChecklist?.filter((item) => !item.checked).length > 0">
                                        <div
                                            class="flex red checklist-item"
                                            v-for="(item, idx) in currentReport.previousChecklist.filter((item) => !item.checked)"
                                            :key="`incomplete-action-${idx}`">
                                            <span class="material-symbols-outlined"> crop_square </span>&nbsp;{{ item.text }}
                                        </div>
                                    </div>
                                    <div v-else>No incomplete actions found.</div>
                                </div>
                            </div>

                            <div class="fullwidth" v-if="tabsSummary == '4'">
                                <label class="label blue flex mb-4">
                                    <span class="material-symbols-outlined"> list_alt_add </span>&nbsp;Linked Asset SMS Audits
                                </label>

                                <div class="buttons">
                                    <div
                                        class="button is-light"
                                        v-for="(item, idx) in currentLinkedSmsAudits"
                                        :key="idx + 'smsaudits'"
                                        @click="viewSmsAudit(item)">
                                        <span class="caps bold blue mr-1">{{ item.vesselName }}</span> -
                                        <span class="ml-1">{{ item.username }} ({{ toDate(item.timestamp)?.toLocaleDateString() }})</span>
                                    </div>
                                </div>
                            </div>

                            <div class="fullwidth" v-if="tabsSummary == '5'">
                                <div class="field">
                                    <label class="label blue flex mb-4">
                                        <font-awesome-icon icon="check-square" /> &nbsp;Client Feedback / Notes
                                    </label>
                                    <LiveDynamicChecklist
                                        key="feedback"
                                        :exists="currentReport.exists"
                                        addItemButtonText="Add Feedback Item"
                                        inputType="text"
                                        :items="feedbackItems"
                                        @addItem="onFeedbackAdd"
                                        @deleteItem="onFeedbackDelete"
                                        @toggleItem="onFeedbackToggle"
                                        @saveItems="onFeedbackSave"
                                        @reorderItems="onFeedbackReorder" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="spacer s100"></div>
                    <!-- <hr /> -->
                    <!-- <pre>{{ currentReport }}</pre> -->
                </div>
            </div>
            <div v-else>
                <div class="spacer s30"></div>
                {{ errorMessage }}
            </div>
        </div>

        <SimpleModal
            v-if="showSmsAuditModal"
            @closed="
                showSmsAuditModal = false;
                selectedSmsAudit = {};
            "
            :title="selectedSmsAudit.vesselName + ': ' + selectedSmsAudit.username"
            :theme="currentReport.exists ? 'is-primary' : 'is-danger'"
            cancelText="Close"
            showCancel>
            <table class="table is-fullwidth">
                <tbody>
                    <tr>
                        <th>Asset Name:</th>
                        <td>{{ selectedSmsAudit.vesselName }}</td>
                    </tr>
                    <tr>
                        <th>Completed By:</th>
                        <td>{{ selectedSmsAudit.username }}</td>
                    </tr>
                    <tr>
                        <th>Date:</th>
                        <td>{{ simpleDate(toDate(selectedSmsAudit.updatedAt ?? selectedSmsAudit.timestamp)) }}</td>
                    </tr>
                    <tr>
                        <th>Notes:</th>
                        <td>{{ selectedSmsAudit.generalNotes }}</td>
                    </tr>
                    <tr>
                        <th>SMS Items Reviewed:</th>
                        <td>{{ selectedSmsAudit.reviewedContentIDs.length }}</td>
                    </tr>
                    <tr v-if="selectedSmsAudit.webLink">
                        <th>View Full Audit</th>
                        <td>
                            <a
                                :href="'https://go.offshoresms.com.au/asset-audit-report/?x=' + (selectedSmsAudit.webLink ?? '')"
                                class="button is-info is-small"
                                target="_blank">
                                <font-awesome-icon icon="link" /> &nbsp;Open link in new tab
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- {{ selectedSmsAudit }} -->
        </SimpleModal>
    </div>
</template>

<script>
import { getFunctions, httpsCallable } from 'firebase/functions';
const aus_functions = getFunctions(undefined, 'australia-southeast1');
const loadFleetReport = httpsCallable(aus_functions, 'asset_functions-loadFleetReport');
const updateFleetReportFeedback = httpsCallable(aus_functions, 'asset_functions-updateFleetReportFeedback');
import LiveDynamicChecklist from '@/reusables/LiveDynamicChecklist.vue';
import { simpleDate } from '@/utilities/helperFunctions';

const SimpleModal = () => import('../reusables/SimpleModal.vue');

export default {
    props: {},

    mounted() {
        let hasParam = this.$route.query && this.$route.query.x;
        if (hasParam) {
            this.xID = this.$route.query.x ? this.$route.query.x : '';
        }
        if (this.xID != '') {
            this.checkCodeExists();
        } else {
            setTimeout(() => {
                self.checkingAccess = false;
                self.errorMessage = 'No report found.';
            }, 1000);
        }
    },

    components: {
        LiveDynamicChecklist,
        SimpleModal
    },

    computed: {
        weblinkMeta() {
            return this.$store.getters.getCurrentWeblinkMeta;
        }
    },

    data() {
        return {
            xID: '',
            status: 'Checking access...',
            errorMessage: '',
            checkingAccess: true,
            loadingReportData: false,
            reportLoaded: false,
            currentReport: null,
            summaryItems: [],
            findingsRecsItems: [],
            checklistItems: [],
            auditChecklistItems: [],
            feedbackItems: [],
            activitiesItems: [],
            selectedSmsAudit: {},
            showSmsAuditModal: false,
            topTabs: '1',
            tabsSummary: '1',
            actionsTally: null,
            auditorTally: null,

            tallyAudits: [
                {
                    label: 'Defects',
                    icon: 'settings',
                    color: 'orange',
                    data: [{ slug: 'snapDefects', label: '* Unresolved Defects', isRed: false }],
                    slugs: ['snapDefects']
                },
                {
                    label: 'Events & Reminders',
                    icon: 'calendar_month',
                    color: 'mediumseagreen',
                    data: [
                        { slug: 'snapDatesOverdue', label: '* Events Overdue', isRed: true },
                        { slug: 'snapDatesDue', label: 'Events Due', isRed: false }
                    ],
                    slugs: ['snapDatesOverdue', 'snapDatesDue']
                },
                {
                    label: 'Planned Maintenance',
                    icon: 'build',
                    color: 'black',
                    data: [
                        { slug: 'snapMaintOverdue', label: '* Maintenance Overdue', isRed: true },
                        { slug: 'snapMaintDue', label: 'Maintenance Due', isRed: false }
                    ],
                    slugs: ['snapMaintOverdue', 'snapMaintDue']
                },
                {
                    label: 'General Inventory',
                    icon: 'handyman',
                    color: 'dodgerblue',
                    data: [
                        { slug: 'snapInventoryLow', label: '* Low Stock Inventory', isRed: false },
                        { slug: 'snapInventoryOverdue', label: 'Inventory Overdue', isRed: true },
                        { slug: 'snapInventoryDue', label: 'Inventory Due', isRed: false }
                    ],
                    slugs: ['snapInventoryLow', 'snapInventoryOverdue', 'snapInventoryDue']
                },
                {
                    label: 'Crew Warnings',
                    icon: 'groups',
                    color: 'red',
                    data: [
                        { slug: 'snapCrewDrills', label: '* Drills Due', isRed: false },
                        { slug: 'snapCrewInductions', label: 'Inductions Due', isRed: true },
                        { slug: 'snapCrewSelfInductions', label: 'Self Inductions Due', isRed: false }
                    ],
                    slugs: ['snapCrewDrills', 'snapCrewInductions', 'snapCrewSelfInductions']
                }
            ],

            months: [
                { value: '01', label: 'January' },
                { value: '02', label: 'February' },
                { value: '03', label: 'March' },
                { value: '04', label: 'April' },
                { value: '05', label: 'May' },
                { value: '06', label: 'June' },
                { value: '07', label: 'July' },
                { value: '08', label: 'August' },
                { value: '09', label: 'September' },
                { value: '10', label: 'October' },
                { value: '11', label: 'November' },
                { value: '12', label: 'December' }
            ],
            years: [
                { value: '2025', label: '2025' },
                { value: '2026', label: '2026' }
            ],
            currentLinkedSmsAudits: []
        };
    },

    methods: {
        close() {
            this.selectedSmsAudit = {};
            this.showSmsAuditModal = false;
        },

        simpleDate,

        toDate(val) {
            if (!val) return null;
            if (val instanceof Date) return val;
            if (typeof val.toDate === 'function') return val.toDate();
            if (val._seconds) return new Date(val._seconds * 1000);
            if (typeof val === 'string' || typeof val === 'number') return new Date(val);
            return null;
        },

        async checkCodeExists() {
            this.errorMessage = '';
            this.status = 'Loading report...';
            this.checkingAccess = true;

            try {
                const result = await loadFleetReport({ webLinkID: this.xID });
                const data = result.data;

                if (!data.success) {
                    this.checkingAccess = false;
                    this.status = 'This report could not be loaded.';
                    this.errorMessage = 'No report found.';
                    return;
                }

                // Store weblink meta
                let weblinkMeta = data.weblinkMeta;
                this.$store.dispatch('setCurrentWeblinkMeta', { weblinkMeta });

                // Populate report data
                this.currentReport = { ...data.report, previousChecklist: data.previousChecklist ?? [] };
                this.currentLinkedSmsAudits = data.linkedSmsAudits ?? [];

                // Populate subcollection data
                const subs = data.subcollections ?? {};
                this.summaryItems = subs['summary'] ?? [];
                this.findingsRecsItems = subs['findings-recommendations'] ?? [];
                this.checklistItems = subs['checklist'] ?? [];
                this.auditChecklistItems = subs['auditChecklist'] ?? [];
                this.feedbackItems = subs['feedback'] ?? [];
                this.activitiesItems = subs['activities'] ?? [];

                this.reportLoaded = true;
                this.status = '';
            } catch (error) {
                console.error('Error loading fleet report:', error);
                this.status = 'This report could not be loaded.';
                this.errorMessage = 'No report found.';
            } finally {
                this.checkingAccess = false;
                this.loadingReportData = false;
            }
        },

        viewSmsAudit(item) {
            this.selectedSmsAudit = { ...item };
            this.showSmsAuditModal = true;
        },

        getColor(val, isRed) {
            return val < 1 ? 'green' : isRed ? 'red' : 'orange';
        },

        truncate(string, limit) {
            return string.length > limit ? string.slice(0, limit) + '...' : string;
        },

        toAlerts(slugs) {
            // this.current_data.setActiveSlugs(slugs);
            // this.$router.push({
            //     name: 'FleetAlertsInfo'
            //     // params: { slugs: slugs }
            // });
        },

        async onFeedbackAdd(index) {
            try {
                const result = await updateFleetReportFeedback({
                    action: 'add',
                    webLinkID: this.xID,
                    itemData: { index }
                });
                if (result.data?.success && result.data?.id) {
                    this.feedbackItems.push({ id: result.data.id, text: '', subtext: '', checked: false, edited: false, index });
                }
            } catch (error) {
                console.error('Error adding feedback item:', error);
            }
        },

        async onFeedbackDelete(itemID) {
            try {
                await updateFleetReportFeedback({
                    action: 'delete',
                    webLinkID: this.xID,
                    itemID
                });
                this.feedbackItems = this.feedbackItems.filter((item) => item.id !== itemID);
            } catch (error) {
                console.error('Error deleting feedback item:', error);
            }
        },

        async onFeedbackToggle(item) {
            try {
                await updateFleetReportFeedback({
                    action: 'update',
                    webLinkID: this.xID,
                    itemID: item.id,
                    itemData: { text: item.text, subtext: item.subtext ?? '', checked: item.checked, index: item.index ?? 0 }
                });
            } catch (error) {
                console.error('Error toggling feedback item:', error);
            }
        },

        async onFeedbackSave(items) {
            try {
                await updateFleetReportFeedback({
                    action: 'save',
                    webLinkID: this.xID,
                    items: items.map((item, idx) => ({ id: item.id, text: item.text, subtext: item.subtext ?? '', checked: item.checked, index: idx }))
                });
            } catch (error) {
                console.error('Error saving feedback items:', error);
            }
        },

        async onFeedbackReorder(items) {
            try {
                await updateFleetReportFeedback({
                    action: 'reorder',
                    webLinkID: this.xID,
                    items: items.map((item, idx) => ({ id: item.id, index: idx }))
                });
            } catch (error) {
                console.error('Error reordering feedback items:', error);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    max-width: 1400px !important;
    padding: 1rem 20px !important;
}
label {
    &.label {
        line-height: 1rem;
        align-items: center;
        display: flex;
    }
}
.table {
    tbody {
        tr {
            th {
                width: 25%;
            }
        }
    }
}

.dash-audit-outer {
    align-items: flex-start;
    display: flex;
    .dash-square-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        margin-right: 1rem;
        align-items: flex-start;
        border: 3px dashed #d8d8d8;
        border-radius: 12px;
        padding: 12px;
        min-height: 260px;
        min-width: 220px;
        margin-bottom: 1.1rem;
        cursor: pointer;
        &.compact {
            min-height: 180px;
        }
        .ds-content {
            width: 100%;
            .ds-header {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .ds-icon {
                    font-size: 1.2rem;
                    color: cadetblue;
                    margin-right: 6px;
                    transition: 0.3s;
                    line-height: 1.1rem;
                }
                .ds-title {
                    font-size: 1rem;
                    color: cadetblue;
                    font-weight: bold;
                    &:after {
                        content: '';
                        width: 0;
                        display: block;
                        width: 0;
                        height: 2px;
                        background: #e4e4e4;
                        transition: 0.3s;
                    }
                }
            }
            .ds-info {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                border-bottom: 1px dashed #e4e4e4;
                padding: 4px 0;
                .ds-details {
                    font-size: 0.8rem;
                }
                .ds-tally {
                    font-size: 1.2rem;
                    font-weight: bold;
                    &.red {
                        color: #f15a5a;
                    }
                }
            }
        }
        .ds-trend {
            width: 100%;
            padding-top: 6px;
            .trend-title {
                font-size: 0.8rem;
            }
        }
        &:hover {
            .ds-header {
                .ds-icon {
                    transform: scale(1.2);
                }
                .ds-title:after {
                    // content: '';
                    width: 100%;
                    // display: block;
                    // width: 100%;
                    // height: 1px;
                    // background: #e4e4e4;
                }
            }
        }
    }
}
.checklist-item {
    padding-bottom: 12px;
    border-bottom: 1px dashed #e4e4e4;
    margin-bottom: 12px;
    width: 100%;
    &:last-of-type {
        border-bottom: none;
        margin-bottom: 0;
    }
}
</style>
